<div class="px-4">
    <div class="wrapper">
        <div class="header d-flex row align-items-center">
            <div class="col-md-9">
                <h5 class="px-4 py-3">Select Page Type</h5>
            </div>
        </div>

        <div class="d-flex flex-wrap content-wrapper w-100" >
            @for(list of contentPageTypeData;track list["pageType"]){
            <ng-container>

                <div [routerLink]="['/content-list', list['pageType']]" (click)="apiService.contentPageType = list['pageType'];apiService.contentPageDesc = list['pageTypeDesc']" [ngClass]="zoomLevel >= 110 ? 'card-width' : ''"
                    class="mt-3 card-box d-flex flex-column justify-content-center align-items-center">
                    <div class="image-box d-flex w-100 align-items-center justify-content-center">
                        <img [src]="list.image">

                    </div>
                    <p class="mb-0 py-2"> {{list['pageTypeDesc']}}
                        <i nz-icon [nzType]="'right'"></i>
                    </p>
                </div>
            </ng-container>
            }
        </div>
    </div>
</div>